<template>
  <v-dialog
    v-model="visibleEdit"
    v-if="visibleEdit"
    width="90%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
    content-class="elevation-0"
  >
    <v-card class="pa-0 ma-0 rounded-xl">
      <v-card-title>
        <v-chip color="green" v-if="$vars.beta" label dark small class="mr-2">Chargenansicht</v-chip>
        {{ localBbr.titel }} {{ localBbr.vorname }} {{ localBbr.nachname }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

      <v-divider></v-divider>
      <v-card-title class="ma-0 pa-0">
        <v-tabs v-model="active" show-arrows center-active>
          <v-tab> Allgemein </v-tab>
          <v-tab> Rechnungen </v-tab>
          <v-tab> Nachrichten </v-tab>
          <v-tab> Änderungen </v-tab>
          <v-tab v-if="currentBbr === 'PBChUyAy7HWowQR4HlP3'"> Debug Data </v-tab>
        </v-tabs>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0 ma-0">
        <v-tabs-items v-model="active" slider-color="red">
          <v-tab-item>
            <v-sheet min-height="calc(90vh - 166px)">
              <v-row no-gutters v-if="active === 0">
                <v-col class="pa-1" cols="6" offset="3" order-xs="5" sm="4" offset-sm="4" md="2" offset-md="0">
                  <v-card outlined class="pa-2">
                    <v-img class="ma-4" :src="localBbr.bildAhnengalerie200"></v-img>
                    <v-btn
                      small
                      outlined
                      block
                      @click="
                        (showPicture = true) &&
                          (uploadStatus = { img_upload: null, img_url1: null, img_url2: null, img_url3: null }) &&
                          (message = undefined)
                      "
                      >Bild bearbeiten</v-btn
                    >
                  </v-card>
                  <v-card outlined class="pa-2 mt-2 text-center">
                    <v-card-title class="d-flex justify-center">
                      <v-progress-circular v-if="loading" size="36" indeterminate color="primary">
                      </v-progress-circular>
                      <span v-else>
                        <v-btn large color="primary" icon @click="changeLoginAllow" v-if="checkMailValue.status"
                          ><v-icon>check_box</v-icon></v-btn
                        >
                        <v-btn large color="primary" icon @click="changeLoginAllow" v-else
                          ><v-icon>check_box_outline_blank</v-icon></v-btn
                        >
                      </span>
                    </v-card-title>
                    <v-card-text>
                      <span v-if="checkMailValue.status"
                        >Der Kontakt darf sich für die App registrieren und einloggen.</span
                      >
                      <span v-else>Registrieren und Einloggen unterbunden.</span>
                    </v-card-text>
                  </v-card>
                  <v-card class="text-center caption pt-4" flat>
                    Zuletzt geändert:
                    <v-chip x-small label
                      ><v-icon x-small class="pr-1">event</v-icon
                      >{{ $filters.date(localBbr.zuletztGeaendertAm, "DD.MM.YYYY hh:mm") }} Uhr</v-chip
                    >
                    <v-chip x-small label
                      ><v-icon x-small class="pr-1">person</v-icon
                      >{{ $filters.user(localBbr.zuletztGeaendertVon, bbrbbr2) }}</v-chip
                    >
                    <v-chip x-small label v-if="localBbr.anmeldeID"
                      ><v-icon x-small class="pr-1">check</v-icon>Account bei Korpodesk</v-chip
                    >
                  </v-card>
                </v-col>
                <v-col class="pa-1" cols="12" md="10" offset-md="0" lg="5" offset-lg="0">
                  <v-card outlined height="100%">
                    <v-card-title class="py-1">Kontaktdaten</v-card-title>
                    <v-divider></v-divider>
                    <v-row no-gutters class="ma-2">
                      <uiKontaktField
                        v-for="(item, index) in felder.neuFelder"
                        :key="index"
                        :feld="item"
                        :value="bbr[item.value]"
                        @dataChange="saveData(...arguments)"
                      ></uiKontaktField>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col class="pa-1" cols="12" md="10" offset-md="2" lg="5" offset-lg="0">
                  <v-card outlined height="100%">
                    <v-card-title class="py-1">Finanzdaten</v-card-title>
                    <v-divider></v-divider>
                    <v-row class="ma-2">
                      <v-col cols="12" class="py-1 px-1" v-if="felder.finanzFelder.showSepaMandat">
                        <v-card outlined>
                          <span class="d-flex justify-start align-center pr-2">
                            <span class="pa-2">
                              <v-icon v-if="localBbr.sepaLastschriftmandat" size="64" color="green"
                                >check_circle_outline</v-icon
                              >
                              <v-icon v-else size="64" color="red">highlight_off</v-icon>
                            </span>
                            <span>
                              <v-card-title class="subtitle-2"> SEPA-Lastschriftmandat </v-card-title>
                              <v-card-subtitle v-if="localBbr.sepaLastschriftmandat">
                                {{ $filters.date(localBbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY") }} Uhr
                              </v-card-subtitle>
                              <v-card-subtitle v-else>
                                Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.
                              </v-card-subtitle>
                            </span>
                            <v-spacer></v-spacer>
                            <span v-if="localBbr.sepaLastschriftmandat">
                              <v-btn icon @click="downloadLastschrift(localBbr.sepaLastschriftmandat)"
                                ><v-icon>download</v-icon></v-btn
                              >
                            </span>
                            <span v-else>
                              <v-btn
                                color="primary"
                                class="text-none"
                                :loading="loadingLaschriftmandatHochladen"
                                @click="clickHochladenLastschriftmandat()"
                              >
                                <v-icon left>cloud_upload</v-icon>Hochladen
                              </v-btn>
                              <input ref="uploader" class="d-none" type="file" accept="pdf/*" @change="onFileChanged" />
                            </span>
                          </span>
                          <v-progress-linear
                            v-if="loadingLaschriftmandatHochladen"
                            indeterminate
                            color="primary"
                          ></v-progress-linear>
                        </v-card>
                      </v-col>
                      <uiKontaktField
                        v-for="(item, index) in felder.finanzFelder.beitrage"
                        :key="index"
                        :feld="item"
                        :value="bbr[item.value]"
                        @dataChange="saveData(...arguments)"
                      ></uiKontaktField>
                      <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                        <v-text-field
                          hide-details="auto"
                          dense
                          outlined
                          :loading="loading_checkIban"
                          @change="checkIban()"
                          label="IBAN"
                          v-model="localBbr.iban"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                        <v-text-field
                          hide-details="auto"
                          dense
                          outlined
                          disabled
                          label="BIC"
                          placeholder="Automatisch berechnet"
                          v-model="localBbr.bic"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" class="py-1 px-1">
                        <v-text-field
                          hide-details="auto"
                          dense
                          outlined
                          label="Kontoinhaber"
                          v-model="localBbr.kontoinhaber"
                          :append-icon="localBbr.kontoinhaber ? '' : 'refresh'"
                          @click:append="localBbr.kontoinhaber = localBbr.vorname + ' ' + localBbr.nachname"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                        <v-text-field
                          hide-details="auto"
                          dense
                          outlined
                          label="Mandatsreferenz"
                          v-model="localBbr.mandatsreferenz"
                          :append-icon="localBbr.mandatsreferenz ? '' : 'refresh'"
                          @click:append="calcMandatsreferenz()"
                        ></v-text-field>
                      </v-col>
                      <uiKontaktField
                        v-if="felder.finanzFelder.showBankdaten"
                        :feld="{
                          breite: 6,
                          label: 'Mandat Unterschriftsdatum',
                          type: 'Date',
                          value: 'mandatUnterschriftsdatum',
                        }"
                        :value="bbr.mandatUnterschriftsdatum"
                        @dataChange="saveData(...arguments)"
                      ></uiKontaktField>
                      <!-- <uiKontaktField v-if="felder.finanzFelder.showBankdaten" :feld="{ breite: 6, label: 'Letzter Lastschrifteinzug', type: 'Date' }" :value="bbr['letzterLastschrifteinzug']" @dataChange="saveData(...arguments)"></uiKontaktField> -->
                      <v-col cols="12" v-if="fehlerSepa.sepa" class="pa-1">
                        <v-alert type="error">{{ fehlerSepa.sepa }}</v-alert>
                      </v-col>
                    </v-row>
                    <span v-if="felder.finanzFelder.showSepaMandat">
                      <v-card-title class="py-1">SEPA-Einstellungen</v-card-title>
                      <v-card-subtitle class="py-1"
                        >Welche Kassen dürfen per SEPA Rechnungen einziehen?</v-card-subtitle
                      >
                      <v-divider></v-divider>
                      <v-row no-gutters class="ma-2">
                        <v-col cols="12" class="py-1 px-1" v-if="disableSEPA">
                          <v-card outlined>
                            <span class="d-flex justify-start align-center pr-2">
                              <span class="pa-2">
                                <v-icon size="64" color="red">warning_amber</v-icon>
                              </span>
                              <span>
                                <v-card-title class="subtitle-2"> Kontodaten fehlen! </v-card-title>
                                <v-card-subtitle>
                                  Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die
                                  Kontodaten eingetragen werden.
                                </v-card-subtitle>
                              </span>
                            </span>
                          </v-card>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-1 px-1"
                          v-for="(item, index) in kassen"
                          :key="index"
                          v-if="item.name"
                        >
                          <v-checkbox
                            dense
                            hide-details
                            class="mb-0 pb-0"
                            :disabled="disableSEPA"
                            on-icon="check_box"
                            off-icon="check_box_outline_blank"
                            v-model="sepa[item.name]"
                            :label="item.name"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </span>
                    <span v-if="$vars.verbindung === 'rbo'">
                      <span v-if="localBbr.versand">
                        <v-card-title class="py-1">Versand-Einstellungen</v-card-title>
                        <v-divider></v-divider>
                        <v-row no-gutters class="ma-2">
                          <v-col cols="12" md="6" class="py-1 px-1">
                            <v-checkbox
                              dense
                              hide-details
                              on-icon="check_box"
                              off-icon="check_box_outline_blank"
                              v-model="localBbr.versand['semesterprogramm']"
                              label="Semesterprogramm"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              hide-details
                              on-icon="check_box"
                              off-icon="check_box_outline_blank"
                              v-model="localBbr.versand['einladungen']"
                              label="Einladungen"
                            ></v-checkbox>
                            <v-checkbox
                              dense
                              hide-details
                              on-icon="check_box"
                              off-icon="check_box_outline_blank"
                              v-model="localBbr.versand['ripuarenblätter']"
                              label="Ripuarenblätter"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </span>
                      <span v-else>
                        <v-row no-gutters class="ma-2">
                          <v-col cols="12" md="6" class="py-1 px-1">
                            <v-btn @click="localBbr.versand = {}" outlined small
                              >Versand-Einstellungen hinzufügen</v-btn
                            >
                          </v-col>
                        </v-row>
                      </span>
                    </span>
                  </v-card>
                </v-col>
                <v-col class="pa-1" cols="12" md="10" offset-md="2" lg="10" offset-lg="2">
                  <v-card outlined height="100%">
                    <v-row no-gutters class="ma-2">
                      <v-col cols="12" class="py-1 px-1">
                        <v-textarea
                          hide-details="auto"
                          dense
                          outlined
                          hint="Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben."
                          rows="5"
                          auto-grow
                          label="Bemerkungen"
                          v-model="localBbr.bemerkungen"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-sheet>
          </v-tab-item>
          <v-tab-item>
            <v-sheet min-height="calc(90vh - 166px)" class="pa-4" color="grey lighten-4">
              <Rechnungen :kontakt="localBbr.id" />
            </v-sheet>
          </v-tab-item>
          <v-tab-item>
            <v-sheet min-height="calc(90vh - 166px)">
              <v-simple-table class="hidden-xs-only" dense fixed-header height="calc(90vh - 166px)" v-if="active === 2">
                <thead>
                  <tr>
                    <th>Absender</th>
                    <th>Betreff</th>
                    <th>Datum</th>
                    <th class="pa-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in nachrichten"
                    :key="item.name"
                    v-on:dblclick="(selectNachricht = item) && (showBbrNachricht = true)"
                  >
                    <td>{{ item.absender.name }}<br />{{ item.absender.position }}</td>
                    <td>{{ item.message.subject }}</td>
                    <td>{{ $filters.date(item.datum, "DD.MM.YYYY hh:mm") }} Uhr</td>
                    <td class="pa-0">
                      <v-btn icon @click="(selectNachricht = item) && (showBbrNachricht = true)"
                        ><v-icon>info</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-card
                class="ma-2 hidden-sm-and-up"
                outlined
                v-for="item in nachrichten"
                :key="item.name"
                v-on:dblclick="(selectNachricht = item) && (showBbrNachricht = true)"
              >
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="text-caption">
                      {{ item.absender.name }} {{ item.absender.position }} |
                      {{ $filters.date(item.datum, "DD.MM.YYYY hh:mm") }} Uhr
                    </v-list-item-title>
                    <div class="subtitle-2">
                      {{ item.message.subject }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-sheet>
          </v-tab-item>
          <v-tab-item>
            <v-sheet min-height="calc(90vh - 166px)">
              <v-simple-table dense fixed-header height="calc(90vh - 166px)" v-if="active === 3">
                <thead>
                  <tr>
                    <th></th>
                    <th>Geändert von</th>
                    <th>Geändert am</th>
                    <th>Geänderte Felder</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in bearbeitungen" :key="index">
                    <td width="20px">{{ index + 1 }}</td>
                    <td>{{ $filters.user(item.dataNeu.zuletztGeaendertVon, bbrbbr2) }}</td>
                    <td>{{ $filters.date(item.dataNeu.zuletztGeaendertAm, "DD.MM.YYYY hh:mm") }} Uhr</td>
                    <td>
                      <v-tooltip bottom v-for="(item2, index2) in item.anders" :key="item2">
                        <template v-slot:activator="{ on }">
                          <v-chip small v-on="on">{{ item2 }}</v-chip>
                        </template>
                        <v-simple-table dense dark class="transparent">
                          <thead>
                            <tr>
                              <th>von</th>
                              <th>zu</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ item.dataAlt[item2] ? item.dataAlt[item2] : "-" }}</td>
                              <td>{{ item.dataNeu[item2] ? item.dataNeu[item2] : "-" }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-sheet>
          </v-tab-item>
          <v-tab-item v-if="currentBbr === 'PBChUyAy7HWowQR4HlP3'">
            <v-sheet min-height="calc(90vh - 166px)">
              <v-simple-table dense fixed-header height="calc(90vh - 166px)" v-if="active === 4">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in localBbr" :key="key">
                    <td>{{ key }}</td>
                    <td v-if="Array.isArray(item)">
                      <v-list dense>
                        <v-list-item v-for="(item2, index) in item" :key="index">
                          <v-list-item-icon>{{ index + 1 }}.</v-list-item-icon>
                          <v-list-item-content>{{ item2 }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </td>
                    <td v-else>{{ item }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-sheet>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mb-6 mb-md-0">
        <v-btn icon @click="showDeleteKontakt = true"><v-icon>delete</v-icon></v-btn>
        {{ localBbr.delete }}
        <v-spacer></v-spacer>
        <v-btn rounded text @click="close()">Schließen</v-btn>
        <v-btn rounded text class="primary" @click="saveBbr()">Speichern</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showPicture" width="40%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>
          Neues Bild hochladen - {{ localBbr.titel }} {{ localBbr.vorname }} {{ localBbr.nachname }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showPicture = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text class="pt-4">
          <v-file-input
            :loading="selectPicture !== '' && (!message || !error)"
            outlined
            dense
            prepend-icon="attach_file"
            v-model="selectPicture"
            label="Neues Bild"
            @change="previewImage"
          ></v-file-input>
          <span v-if="uploadStatus.img_upload !== null">
            <v-progress-linear
              class="mb-2"
              :color="uploadValue === 100 ? 'green' : 'blue'"
              :value="uploadValue"
              height="32"
              rounded
              >Upload ({{ uploadValue.toFixed(0) }} %)</v-progress-linear
            >
            <v-progress-linear
              class="mb-2"
              :color="uploadStatus.img_url1 ? 'green' : 'blue'"
              :value="uploadStatus.img_url1 ? 100 : 0"
              :indeterminate="uploadStatus.img_url1 === false"
              height="32"
              rounded
              >Bild 1 berechnen</v-progress-linear
            >
            <v-progress-linear
              class="mb-2"
              :color="uploadStatus.img_url2 ? 'green' : 'blue'"
              :value="uploadStatus.img_url2 ? 100 : 0"
              :indeterminate="uploadStatus.img_url2 === false"
              height="32"
              rounded
              >Bild 2 berechnen</v-progress-linear
            >
            <v-progress-linear
              class="mb-2"
              :color="uploadStatus.img_url3 ? 'green' : 'blue'"
              :value="uploadStatus.img_url3 ? 100 : 0"
              :indeterminate="uploadStatus.img_url3 === false"
              height="32"
              rounded
              >Bild 3 berechnen</v-progress-linear
            >
          </span>
          Neben dem Originalbild werden noch 3 weitere Versionen gespeichert. Falls ein Fehler auftritt lad die Seite
          bitte neu und versuch das Bild erneut hochzuladen.

          <v-alert v-if="message" type="success">{{ message }}</v-alert>
          <v-alert v-if="uploadStatus.error" type="warning">
            Es ist ein Fehler aufgetreten. Bitte lade die Seite neu.
            <br /><br />
            {{ uploadStatus.error }}
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="selectPicture !== '' && !(!message || !error)" text @click="showPicture = false"
            >Schließen</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogDelete
      :visible.sync="showDeleteKontakt"
      title="Kontakt löschen"
      message="Willst du diesen Kontakt wirklich löschen? Der Kontakt wird dabei als gelöscht markiert und erscheint in keinen weiteren Auflistungen. Er kann aber zu einem späteren Zeitpunkt wieder hergestellt werden. Eine endgültige Löschung ist nicht möglich."
      abbrechen="Abbrechen"
      weiter="Löschen"
      @closeTrue="deleteKontakt()"
      @closeFalse="showDeleteKontakt = false"
    >
    </dialogDelete>

    <dialogRechnung
      :visible.sync="showBbrRechnung"
      :rechnungid="selectRechnung.id"
      @close="showBbrRechnung = false"
    ></dialogRechnung>
    <v-dialog
      v-model="showBbrNachricht"
      width="60%"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      scrollable
      v-if="selectNachricht"
    >
      <v-card class="pa-0 ma-0">
        <v-card-title>
          {{ selectNachricht.message.subject }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showBbrNachricht = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ $filters.date(selectNachricht.datum, "DD.MM.YYYY") }} von {{ selectNachricht.absender.name }}
        </v-card-subtitle>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text class="ma-0 pa-4 emailFeld" v-html="selectNachricht.message.html"> </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showBbrNachricht = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import axios from "axios";
  import Rechnungen from "../../main/Rechnungen.vue";
  export default {
    props: ["bbr", "visibleEdit"],
    components: {
      Rechnungen,
    },
    data() {
      return {
        localBbr: this.bbr,
        loading: false,
        loading_checkIban: false,
        checkMailValue: {},
        active: 0,
        date: "",
        menu5: "",
        menu6: "",
        sepa: this.bbr.sepa ? this.bbr.sepa : {},
        fehlerSepa: {},
        selectPicture: "",
        uploadStatus: {
          img_upload: null,
          img_url1: null,
          img_url2: null,
          img_url3: null,
        },
        showPicture: false,
        uploadValue: "",
        img1: "",
        imageData: "",
        message: undefined,
        rules: {
          required: (value) => !!value || false,
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Flasches E-Mail-Format";
          },
          telefonnummer: (value) => {
            const pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
            return pattern.test(value) || "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen";
          },
          geld: (value) => {
            const pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
            return pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
          },
        },
        showBbrRechnung: false,
        selectRechnung: "",
        showBbrNachricht: false,
        selectNachricht: "",
        showDeleteKontakt: false,
        selectedFile: null,
        loadingLaschriftmandatHochladen: false,
        today: new Date().toISOString().substr(0, 10),
      };
    },
    beforeMount() {
      this.loading = true;
      this.checkMailValue = { status: null };
      var functions = this.$firebase.functions();
      if (this.localBbr.email) {
        functions
          .httpsCallable("userLoginAllowed")({ email: this.localBbr.email.toLowerCase(), sub: this.$vars.verbindung })
          .then(({ data }) => {
            this.loading = false;
            this.checkMailValue = data;
          })
          .catch((error) => {
            console.log(error);
            this.error = error;
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.checkMailValue = { status: null };
      }
    },
    computed: {
      bbrbbr2() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      felder() {
        const kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
        return kontaktfelder === undefined ? {} : kontaktfelder;
      },
      kassen() {
        return this.$store.state.einstellungen.einstellungen.find((item) => item.id === "kassen");
      },
      disableSEPA() {
        return (
          !this.localBbr.bic ||
          !this.localBbr.kontoinhaber ||
          !this.localBbr.mandatsreferenz ||
          !this.localBbr.mandatUnterschriftsdatum
        );
      },
      bearbeitungen() {
        console.log("Lade Bearbeitugne Edit Contact");
        if (this.$store.state.bearbeitungen.bearbeitungen.length === 0) {
          this.$store.dispatch("bearbeitungen/loadBearbeitungen");
        }
        let bearbeitungen = [];
        this.$store.getters["bearbeitungen/bearbeitungVonBbr"](this.localBbr.id).forEach((item) => {
          let diff = [];
          for (const [key] of Object.entries(item.dataNeu)) {
            if (
              [
                "zm",
                "chargen",
                "einstellungen",
                "notificationToken",
                "zuletztGeaendertAm",
                "zuletztGeaendertVon",
              ].indexOf(key) === -1
            ) {
              if (item.dataNeu[key] !== item.dataAlt[key]) {
                diff.push(key);
              }
            }
          }
          item.anders = diff;
          bearbeitungen.push(item);
        });
        return bearbeitungen;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      nachrichten() {
        if (this.$store.state.mails.loaded === false) {
          this.$store.dispatch("mails/loadMails");
        }
        return this.$store.getters["mails/eigeneMails"](this.localBbr.id);
      },
      formatletzterLastschrifteinzug() {
        if (!this.localBbr.letzterLastschrifteinzug) return null;
        return new Date(this.localBbr.letzterLastschrifteinzug).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatmandatUnterschriftsdatum() {
        if (!this.localBbr.mandatUnterschriftsdatum) return null;
        return new Date(this.localBbr.mandatUnterschriftsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
    },
    methods: {
      saveData(value, feld) {
        console.log("saveData", feld, value);
        console.log(feld.value);
        console.log(this.bbr[feld.value]);
        this.bbr[feld.value] = value;
      },
      clickHochladenLastschriftmandat() {
        console.log("clickHochladenLastschriftmandat");
        this.loadingLaschriftmandatHochladen = true;
        window.addEventListener("focus", () => {}, { once: true });

        this.$refs.uploader.click();
      },
      onFileChanged(e) {
        this.selectedFile = e.target.files[0];
        const fileName = this.localBbr.id;
        const storagePath = `/sepaLastschriftmandat/${this.$vars.verbindung}/`;
        const storageRef = this.$firebase
          .storage()
          .ref(storagePath + fileName)
          .put(this.selectedFile);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            console.log((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.localBbr.sepaLastschriftmandat = {
                url: url,
                date: new Date(),
                name: "SEPA-Lastschrift-" + this.localBbr.nachname + "-" + this.localBbr.vorname,
              };
              this.loadingLaschriftmandatHochladen = false;
            });
          }
        );
      },
      downloadLastschrift(file) {
        var link = document.createElement("a");
        link.setAttribute("href", file.url);
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      changeLoginAllow() {
        console.log("changeLoginAllow");
        this.loading = true;
        this.checkMailValue = { status: null };
        var functions = this.$firebase.functions();
        functions
          .httpsCallable("changeLoginAllow")({ email: this.localBbr.email.toLowerCase(), sub: this.$vars.verbindung })
          .then(({ data }) => {
            this.loading = false;
            this.checkMailValue = data;
          })
          .catch((error) => {
            console.log(error);
            this.error = error;
            this.loading = false;
          });
      },
      previewImage(event) {
        this.message = "";
        this.uploadValue = 0;
        this.img1 = null;
        this.imageData = event;
        this.onUpload();
      },
      deleteKontakt() {
        this.localBbr.delete = true;
        this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
        this.showDeleteKontakt = false;
        this.showBbr = false;
        this.localBbr = [];
      },
      calcMandatsreferenz() {
        this.localBbr.mandatsreferenz = (
          this.localBbr.vorname.slice(0, 3) +
          this.localBbr.nachname.slice(0, 3) +
          Math.floor(Math.random() * 90000000 + 10000000)
        ).toUpperCase();
        this.localBbr.mandatsreferenz = this.localBbr.mandatsreferenz.replace(/[^A-Z0-9]/g, "");
      },
      saveBbr() {
        this.localBbr.sepa = this.sepa;
        console.log(this.localBbr);
        if (this.localBbr.adresse) {
          let link = "https://nominatim.openstreetmap.org/search.php?q=";
          if (this.localBbr.adresse) {
            link = link + this.localBbr.adresse.replaceAll(" ", "%20") + "+";
          }
          if (this.localBbr.ort) {
            link = link + this.localBbr.ort.replaceAll(" ", "%20") + "+";
          }
          if (this.localBbr.plz) {
            link = link + String(this.localBbr.plz).replaceAll(" ", "%20") + "+";
          }
          if (this.localBbr.land) {
            link = link + this.localBbr.land.replaceAll(" ", "%20") + "+";
          }
          link = link + "&format=jsonv2";
          fetch(link)
            .then((response) => response.json())
            .then((data) => {
              if (data[0].lat) {
                this.localBbr.x = data[0].lat;
              }
              if (data[0].lon) {
                this.localBbr.y = data[0].lon;
              }
              this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
              this.$emit("close", false);
              this.showBbr = false;
              this.localBbr = [];
            })
            .catch(() => {
              this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
              this.$emit("close", false);
              this.showBbr = false;
              this.localBbr = [];
            });
        } else {
          this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
          this.$emit("close", false);
          this.showBbr = false;
          this.localBbr = [];
        }
      },
      async checkIban() {
        if (this.localBbr.iban) {
          try {
            this.loading_checkIban = true;
            const url = `https://openiban.com/validate/${this.localBbr.iban}?getBIC=true&validateBankCode=true`;
            const response = await axios.get(url);
            if (response.data.valid) {
              this.localBbr.bic = response.data.bankData.bic;
              this.fehlerSepa.sepa = null;
            } else {
              this.localBbr.bic = "";
              Object.keys(this.sepa).forEach((key) => {
                this.sepa[key] = false;
              });
              this.fehlerSepa.sepa = "Die IBAN ist nicht korrekt.";
            }
            this.loading_checkIban = false;
          } catch (error) {
            console.error("Fehler beim Abrufen der IBAN:", error);
            this.loading_checkIban = false;
          }
        } else {
          this.localBbr.bic = "";
        }
      },
      onUpload() {
        this.uploadStatus = {
          img_upload: false,
          img_url1: null,
          img_url2: null,
          img_url3: null,
          error: "",
        };
        this.img1 = null;
        let img2 = null;
        let img3 = null;
        const storageRef = this.$firebase
          .storage()
          .ref(`/ahnengalerie/${this.localBbr.rbonummer + this.localBbr.nachname + this.localBbr.vorname}`)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            this.uploadStatus.error = error.message;
          },
          () => {
            this.uploadStatus.img_upload = true;
            this.uploadValue = 100;
            this.uploadStatus.img_url1 = false;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.img1 = url;
              this.localBbr.bildAhnengalerie = this.img1;
              this.uploadStatus.img_url1 = true;
              this.uploadStatus.img_url2 = false;
              setTimeout(() => {
                console.log(storageRef.snapshot.ref.fullPath);
                // Get URL for second image
                this.$firebase
                  .storage()
                  .ref(storageRef.snapshot.ref.fullPath + "_200x200")
                  .getDownloadURL()
                  .then((url) => {
                    this.uploadStatus.img_url2 = true;
                    this.uploadStatus.img_url3 = false;
                    img2 = url;
                    this.localBbr.bildAhnengalerie200 = img2;
                    this.$firebase
                      .storage()
                      .ref(storageRef.snapshot.ref.fullPath + "_500x500")
                      .getDownloadURL()
                      .then((url) => {
                        this.uploadStatus.img_url3 = true;
                        img3 = url;
                        this.localBbr.bildAhnengalerie500 = img3;
                        this.$store.dispatch("bbrbbr/updateBbrData", this.localBbr);
                        this.message = "Upload erfolgreich";
                        this.selectPicture = "";
                      })
                      .catch((error) => {
                        this.uploadStatus.error = error;
                      });
                  })
                  .catch((error) => {
                    this.uploadStatus.error = error;
                  });
              }, 2000);
            });
          }
        );
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogKontaktEdit.vue?6e06140e